import { Blend } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BlendIcon = createLucideIcon(Blend);
